import * as apiPublish from 'apiAuto/backend/paths/PostMenuPlannerPublishmenuPlanIdpublishV1';

export * as State from './State';

export type Type = {
	selectedLocationGroup: string[];
};

export function create(): Type {
	return {
		selectedLocationGroup: [],
	};
}

export function toggleString(obj: Type, input: string): Type {
	const newSelectedLocationGroup = [...obj.selectedLocationGroup];
	if (newSelectedLocationGroup.includes(input)) {
		newSelectedLocationGroup.splice(newSelectedLocationGroup.indexOf(input), 1);
	} else {
		newSelectedLocationGroup.push(input);
	}
	return { ...obj, selectedLocationGroup: newSelectedLocationGroup };
}

export async function sendToApi(obj: Type, input?: { menuPlanId: string }): Promise<Type> {
	if (!input) return obj;
	await apiPublish.callApi({
		pathParameters: { menuPlanId: input.menuPlanId },
		requestBody: obj.selectedLocationGroup,
	});
	return { ...obj, selectedLocationGroup: [] };
}
